// extracted by mini-css-extract-plugin
export default {"consent-management-widget":"consent-widget-module_consent-management-widget_U3rhyIcX"};